import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { PersonalData } from '../services/payment.service';

@Injectable({ providedIn: 'root' })
export class PersonalDataResolver implements Resolve<PersonalData> {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): PersonalData {
    return {
      name: route.queryParams.name,
      surname: route.queryParams.surname,
      email: route.queryParams.email
    };
  }
}
